export default __webpack_public_path__ + "static/media/Group630@2x.ba00c4c3.png";